// extracted by mini-css-extract-plugin
module.exports = {"banner":"AvisRentACar_banner__maWXj","article":"AvisRentACar_article__xVI3v","reviews":"AvisRentACar_reviews__vxcoq"};